<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <span class="ugo-form-view-text" :class="{ 'ugo-form-view-empty': value === null || value === undefined || value === '' }">
      {{ viewDisplayText }}
      <span v-if="config?.unit" style="color:var(--subtext2);font-size:12px;margin-left:4px;">{{ config.unit }}</span>
    </span>
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required">
    <InputNumber
      v-model="_value"
      :disabled="!editable"
      :max="this?.config?.max"
      :min="this?.config?.min"
      :formatter="formatter"
      :style="`width:${config?.width || '100%'}`"
    >
        <div slot="prefix" class="flex-wrap"  style="height:100%;margin-left:5px;color:var(--subtext2);">￥</div>
      </InputNumber>
      <div class="flex-wrap flex-right" style="color:var(--subtext2);font-size:12px;" v-if="config?.unit">{{ config?.unit }}</div>
  </FormItem>
  </div>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin, { EMPTY_VIEW_TEXT } from '../mixins/as-view';
export default {
  mixins: [defaultValueMixin, valueDefMixin, asViewMixin],
  methods: {
    getValueDef() {
      return this.valueDefNumber();
    },
    formatter(v) {
      const df = (e)=>e;
      const fm = {
        amount: (value) => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        percent: (value) => `${value}%`,
      };
      return (fm[this?.config?.type] || df)(v);
    },
  },
  cname: '数值',
  icon: 'shuzhi',
  corder: 1,
  props: ['value', 'label', 'config', 'required', 'editable'],
  computed: {
    _value: {
      get() {
        return this.value || 0;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    viewDisplayText() {
      if (this.value === null || this.value === undefined || this.value === '') {
        return EMPTY_VIEW_TEXT;
      }
      return this.formatter(this.value);
    },
  },
  properties: [
    {
      label: '宽度',
      key: 'width',
      control: 'Text',
    },
    {
      label: '类型',
      key: 'type',
      control: 'Select',
      option: {
        options: [{
          value: 'default',
          label: '默认',
        }, {
          value: 'amount',
          label: '金额',
        }, {
          value: 'percent',
          label: '百分比',
        }],
        defaultTo: 'default',
      },
    },
    {
      label: '单位',
      key: 'unit',
      control: 'Text',
    },

  ],
};
</script>

<style lang="less" scoped>

</style>
